// import { InputWithLabel } from '@adotel/components'

// import { OperationVariables, ApolloQueryResult } from '@apollo/client'

import { useLazyQuery } from '@apollo/client'
import { Button, Collapse, useTheme } from '@material-ui/core'
import FilterListIcon from '@material-ui/icons/FilterList'
import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify'

import AdotelSkeleton from '../../components/AdotelSkeleton'
import PageHeader from '../../components/PageHeader'
import SectionTitle from '../../components/SectionTitle'
import { CHANNEL_PUSH_MONITORING_QUERY } from '../../graphql/channelPush'
import { getTranslate } from '../../localization'
import { ChannelMonitoring } from '../../types/channelPush'
import { ChannelPushMonitoringFiltersInput } from '../../types/channelPush'
import ChannelsTabelHead from './ChannelsTabelHead'
import { ChannelsTableRow } from './ChannelsTableRow'
import PushMonitoringFilters from './PushMonitoringFilters'
import useStyles from './styles/index.styles'

const ChannelPushMonitoring = () => {
  const classes = useStyles()
  const theme = useTheme()
  const [filterButtonSelected, setFilterButtonSelected] =
    useState<boolean>(false)
  const [filters, setfilters] = useState<ChannelPushMonitoringFiltersInput>({})
  const [channelOptions, setchannelOptions] = useState<ChannelMonitoring[]>([])

  const webHookMenuItems: { label: string; value: string }[] = [
    { label: 'Adotel Connect v.1', value: 'Standard' },
    { label: 'RezGain Bridge v.2', value: 'RateGain' },
    { label: 'Acomotel v.1', value: 'Wozozo' },
    { label: 'SnappTrip v.1', value: 'Snapp' }
  ]
  const valueToLabelMap = new Map(
    webHookMenuItems.map((item) => [item.value, item.label])
  )
  const getWebHookLabelByValue = (value: string): string | undefined => {
    return valueToLabelMap.get(value)
  }
  const [getChannelPushMonitoring, { loading, data, refetch }] = useLazyQuery<{
    channelPushMonitoring: ChannelMonitoring[]
  }>(CHANNEL_PUSH_MONITORING_QUERY, {
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'cache-and-network',
    onError: (err) => {
      toast.error(err.message)
    },
    onCompleted: (d) => {
      if (channelOptions.length == 0)
        setchannelOptions(d?.channelPushMonitoring)
    }
  })
  useEffect(() => {
    getChannelPushMonitoring({
      variables: {
        filters: filters
      }
    })
  }, [])
  let i = 0

  return (
    <div>
      <PageHeader title={getTranslate('Push monitoring')} />
      <div className={classes.channelsSectionHeader}>
        <SectionTitle
          title={getTranslate('Channels Push Monitoring')}
          marginBottom
        />
        <div className={classes.buttons}>
          <Button
            size={'medium'}
            startIcon={<FilterListIcon />}
            variant="contained"
            color="primary"
            onClick={() => {
              setFilterButtonSelected(!filterButtonSelected)
            }}>
            {getTranslate('Filter')}
          </Button>
        </div>
      </div>
      <Collapse in={filterButtonSelected}>
        <PushMonitoringFilters
          filters={filters}
          setfilters={setfilters}
          data={channelOptions}
          getChannelPushMonitoring={getChannelPushMonitoring}
        />
      </Collapse>

      <div className={classes.channelsContainer}>
        <ChannelsTabelHead refetch={refetch} />
        {data?.channelPushMonitoring?.map((item, index) =>
          item.webHooks.map((ad) => {
            i++
            return (
              <ChannelsTableRow
                key={index}
                channel={item}
                adapter={ad}
                getWebHookLabelByValue={getWebHookLabelByValue}
                isOdd={i % 2 !== 0}
              />
            )
          })
        )}
      </div>
      <AdotelSkeleton
        open={loading}
        circlesColor={theme.palette.primary.main}
        numberOfCircles={4}
      />
    </div>
  )
}

export default ChannelPushMonitoring
